/* eslint-disable max-len */
import { PaymentMethods, PaymentTypes } from 'services/api/PaymentApi/types/common'

import { projectStyledName } from 'shared/constants'
import { LanguagesType } from 'shared/locale'

type IDescriptionType = Record<string, Record<LanguagesType, string>>

const descriptionForPayment: IDescriptionType = {
  [`${PaymentTypes.PAYOUT}_${PaymentMethods.PIX}`]: {
    'en-US': `
      <ul>
        <li>1. It is only possible to request a withdrawal after 24 hours of your last withdrawal.</li>
        <li>2. Withdrawals can take up to 30 minutes to process.</li>
        <li>
          3. Before making the withdrawal request, make sure you have the CPF registered with ${projectStyledName} 
          as a PIX key in your banking application.
        </li>
      </ul>
    `,
    'fr-fr': `
      <ul>
        <li>1. Il n'est possible de demander un retrait qu'après 24 heures de votre dernier retrait.</li>
        <li>2. Les retraits peuvent prendre jusqu'à 30 minutes pour être traités.</li>
        <li>
          3. Avant de faire la demande de retrait, assurez-vous d'avoir le CPF enregistré avec ${projectStyledName} 
          comme clé PIX dans votre application bancaire.
        </li>
      </ul>
    `,
    'ar-ar': `
      <ul>
        <li>1. لا يمكن طلب السحب إلا بعد مرور 24 ساعة من آخر عملية سحب.</li>
        <li>2. قد تستغرق عمليات السحب ما يصل إلى 30 دقيقة للمعالجة.</li>
        <li>
          3. قبل تقديم طلب السحب، تأكد من أن لديك CPF مسجلاً لدى ${projectStyledName}
          كمفتاح PIX في تطبيقك البنكي.
        </li>
      </ul>
    `,
  },
}

export const getDescriptionByCurrentPayment = ({ lang, paymentKey }: { lang: LanguagesType; paymentKey: string }) => ({
  __html: descriptionForPayment[paymentKey]?.[lang] ?? descriptionForPayment[paymentKey]?.['en-US'] ?? '',
})
